function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,7,0)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 438 0 L 111 0 C 49 0 0 50 0 112 L 0 131 L 0 798 L 0 887 C 0 949 49 1000 111 1000 L 438 1000 C 500 1000 550 949 550 887 L 550 798 L 550 131 L 550 112 C 550 50 500 0 438 0 z M 275 954 C 244 954 220 929 220 899 C 220 868 244 843 275 843 C 305 843 330 868 330 899 C 330 929 305 954 275 954 z M 509 798 L 40 798 L 40 131 L 509 131 L 509 798 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.50e86b61912135fcf4ab4a92a968f834.svg";
export { ForwardRef as ReactComponent };